export const herbSearch = () => {
  const searchInput = document.querySelector('.search__box');
  const searchResultsContainer = document.querySelector('.search__results');
  const overlay = document.querySelector('.background-overlay');
  const searchContainer = document.querySelector('.search__container');

  if (!searchInput || !searchResultsContainer || !overlay || !searchContainer) {
    return;
  }

  let searchResultsDisplayed = false;

  searchInput.addEventListener('input', function () {
    const query = this.value.toLowerCase();
    handleSearch(query);
  });

  searchInput.addEventListener('focus', function () {
    const query = this.value.toLowerCase();

    if (query.length > 1 && searchResultsDisplayed) {
      showSearchResults();
    } else if (query.length > 1) {
      handleSearch(query);
    }
  });

  document.addEventListener('click', function (e) {
    if (!searchInput.contains(e.target) && !searchResultsContainer.contains(e.target)) {
      closeSearch();
    }
  });

  function handleSearch(query) {
    searchResultsContainer.innerHTML = '';

    if (query.length <= 1) {
      closeSearch();
      return;
    }

    const normalizedQuery = query.trim().replace(/\s+/g, ' ').toLowerCase();

    if (normalizedQuery.length <= 1) {
      closeSearch();
      return;
    }

    const filteredHerbs = window.herbs.filter(
      (herb) => normalizedQuery && herb.title.toLowerCase().includes(normalizedQuery),
    );

    if (filteredHerbs.length > 0) {
      filteredHerbs.forEach((herb) => {
        const herbElement = document.createElement('a');
        herbElement.href = herb.url;
        herbElement.classList.add('block', 'cursor-pointer');
        herbElement.textContent = herb.title;
        searchResultsContainer.appendChild(herbElement);
      });

      showSearchResults();
      searchResultsDisplayed = true;
    } else {
      closeSearch();
    }
  }

  function showSearchResults() {
    searchResultsContainer.classList.remove('hidden');
    searchResultsContainer.classList.add('flex', 'flex-col', 'gap-2');
    searchInput.classList.remove('rounded-3xl');
    searchInput.classList.add('rounded-t-3xl');
    overlay.classList.remove('hidden');
    searchContainer.classList.add('z-50');
  }

  function closeSearch() {
    searchResultsContainer.classList.add('hidden');
    searchResultsContainer.classList.remove('flex', 'flex-col', 'gap-2');
    searchInput.classList.remove('rounded-t-3xl');
    searchInput.classList.add('rounded-3xl');
    overlay.classList.add('hidden');
    searchContainer.classList.remove('z-50');
    searchResultsDisplayed = false;
  }
};
